import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { ParticipantViewModel } from "../models/participant-view-model";
import { CreateResult } from "../models/create-result";
import { TMSinkNodesViewModel } from '../models/sink-nodes-view-model';
import { SinkNodeMappingConfigViewModel } from "../models/sinknode-mapping-config-view-model";
import { ParticipantMappingViewModel } from '../models/participant-mapping-view-model';
import { CustomTagParticipantLinkViewModel } from '../models/card-set-participant-link';
import { CustomServicesConfigModel } from '../models/custom-service-config-mode';
import { SinkNodesUpdateViewModel } from '../models/sink-nodes-update-view-model';
import { SettingsViewModel } from '../models/settings-view-model';

@Injectable({
  providedIn: 'root'
})
export class ParticipantService {
  

  constructor(private _httpService: HttpService) {
  }

  public async GetAllParticipants(): Promise<ParticipantViewModel[]> {
    const httpResult = await this._httpService.apiGet<ParticipantViewModel[]>(`participant/all`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetParticipantByMerchantId(merchantNumber: string): Promise<ParticipantViewModel> {

    const httpResult = await this._httpService.apiGet<ParticipantViewModel>(`participant/byMerchantId/${merchantNumber}`);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }
   

  public async GetEnableCustomNedbankPFI(): Promise<boolean> {
    const httpResult = await this._httpService.apiGet<boolean>(`participant/GetEnableCustomNedbankPFI`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return false;
  }

  public async GetEnableAbsaBase24SaPFI(): Promise<boolean> {
    const httpResult = await this._httpService.apiGet<boolean>(`participant/GetEnableAbsaBase24SaPFI`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return false;
  }

  public async GetParticipant(id: number): Promise<ParticipantViewModel> {
    const httpResult = await this._httpService.apiGet<ParticipantViewModel>(`participant/Single/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }


  public async GetParticipantById(id: number): Promise<ParticipantViewModel> {
    const httpResult = await this._httpService.apiGet<ParticipantViewModel>(`participant/GetParticipantById/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetAggregateMerchant(id: number): Promise<ParticipantViewModel> {

    const httpResult = await this._httpService.apiGet<ParticipantViewModel>(`participant/getAggregatorMerchant/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }

  public async GetUserParticipants(userId: string): Promise<ParticipantViewModel[]> {
    const httpResult = await this._httpService.apiGet<ParticipantViewModel[]>(`participant/user`, { userId: userId });
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async Sync(): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`participant/sync`, {});
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async Update(participant: ParticipantViewModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`participant/${participant.id}`, participant);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async AddUpdateSettings(settings: SettingsViewModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`participant/Settings`, settings);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async Import(): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`participant/import`, {});
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async Export(sinkNodes: SinkNodesUpdateViewModel[], count: number): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`participant/emport/${count}`, sinkNodes);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async UpdateSinkNode(sinkNodeMappedFields: ParticipantMappingViewModel): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPut<CreateResult>(`participant/UpdateSinkNode`, sinkNodeMappedFields);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async DeleteSinkNode(id: number): Promise<CreateResult> {

    const httpResult = await this._httpService.apiGet<CreateResult>(`participant/DeleteSinkNodes/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;

    } return { message: "An unknown error occured", success: false };
  }

  public async UpdateSinkNodes(sinkNodeMappedFields: ParticipantMappingViewModel[]): Promise<CreateResult> {

    const httpResult = await this._httpService.apiPost<CreateResult>(`participant/UpdateSinkNodes`, sinkNodeMappedFields);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return { message: "An unknown error occured", success: false };
  }

  public async GetParticipantMappingSinkNodes(id: number): Promise<ParticipantMappingViewModel[]> {

    const httpResult = await this._httpService.apiGet<ParticipantMappingViewModel[]>(`participant/GetParticipantMappingsSinkNodes/${id}`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return [];
  }

  public async GetSinkNodes(): Promise<TMSinkNodesViewModel[]> {
    const httpResult = await this._httpService.apiGet<TMSinkNodesViewModel[]>(`participant/GetSinkNodes`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetAvailableSinkNodes(participantId: number): Promise<TMSinkNodesViewModel[]> {
    const httpResult = await this._httpService.apiGet<TMSinkNodesViewModel[]>(`participant/GetAvailableSinkNodes/${participantId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

  public async GetSerialNumberField(participantId: number): Promise<SettingsViewModel> {
    const httpResult = await this._httpService.apiGet<SettingsViewModel>(`participant/GetSerialNumberField/${participantId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }


  public async GetSinkNodeMappedConfigs(): Promise<SinkNodeMappingConfigViewModel[]> {
    const httpResult = await this._httpService.apiGet<SinkNodeMappingConfigViewModel[]>(`participant/GetAllSinkNodeMappedConfigs`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return [];
  }

  public async GetSinkNodeMappedConfigsByMerchant(merchantNumber: string): Promise<SinkNodeMappingConfigViewModel[]> {
    const httpResult = await this._httpService.apiGet<SinkNodeMappingConfigViewModel[]>(`participant/${merchantNumber}/GetAllSinkNodeMappedConfigs`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body);
    }
    return [];
  }

  public async GetDefaultMapDescriptions(): Promise<SinkNodeMappingConfigViewModel[]> {
    const httpResult = await this._httpService.apiGet<SinkNodeMappingConfigViewModel[]>(`participant/GetDefaultMapDescription`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body).result;
    }
    return [];
  }

  public async GetDefaultSinkNode(): Promise<TMSinkNodesViewModel[]> {
    const httpResult = await this._httpService.apiGet<TMSinkNodesViewModel[]>(`participant/GetDefaultSinkNode`);
    if (httpResult && httpResult.body) {
      return (<any>httpResult.body).result;
    }
    return [];
  }


  public async GetParticipantsByClient(): Promise<ParticipantViewModel[]> {
    const httpResult = await this._httpService.apiGet<ParticipantViewModel[]>(`participant/GetParticipantsByClient`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return [];
  }

}
